(function scrollReveal() {
  if (!('IntersectionObserver' in window)) return;

  const IGNORE_SELECTOR = '.marquee, .slideshow, comparison-slider, [data-scroll-reveal-ignore]';
  const STAGGER_STEP_MS = 60;
  const STAGGER_MAX_MS = 240;

  document.documentElement.classList.add('js-animations');

  const main = document.getElementById('MainContent');
  if (!main) return;

  const candidates = main.querySelectorAll(
    '.shopify-section, .section-content-wrapper > *, .group-block-content > *'
  );
  const revealables = [];

  for (const el of candidates) {
    if (el.closest(IGNORE_SELECTOR)) continue;
    el.setAttribute('data-scroll-reveal', '');
    revealables.push(el);
  }

  // Stagger siblings that reveal together within the same section.
  const staggerGroups = new Map();
  for (const el of revealables) {
    if (el.classList.contains('shopify-section')) continue;
    const section = el.closest('.shopify-section');
    if (!section) continue;
    if (!staggerGroups.has(section)) staggerGroups.set(section, []);
    staggerGroups.get(section).push(el);
  }
  for (const children of staggerGroups.values()) {
    children.forEach((el, index) => {
      el.style.setProperty('--scroll-reveal-delay', `${Math.min(index * STAGGER_STEP_MS, STAGGER_MAX_MS)}ms`);
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('scroll-reveal-visible');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  /**
   * Elements already in the viewport at load (the hero, above-the-fold content) intersect the
   * instant they're observed. Without a paint in between, the browser has nothing to transition
   * *from* and jumps straight to the visible state. Waiting two animation frames guarantees the
   * hidden state has actually been painted once before observation starts, so those elements
   * fade in too instead of only ones revealed later by a real scroll.
   */
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      for (const el of revealables) observer.observe(el);
    });
  });
})();
